import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { Paths } from '../../enums/paths.enum';
import { RouteLabels } from '../../enums/routeLabels.enum';
import { EditUserGeneralInformationPage } from '../../pages/edit-user/general-information/edit-user-general-information.page';
import { EditUserSecurityPage } from '../../pages/edit-user/security/edit-user-security.page';
import { AuthGuard } from '../../shared/auth.guard';
import { CanDeactivateGuard } from '../../shared/can-deactivate.guard';
import { PageNotFoundComponent } from '../../components/page-not-found/page-not-found.component';
import { I18NextModule } from 'angular-i18next';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', redirectTo: `${Paths.USER_GENERAL_INFORMATION}`, pathMatch: 'full' },
            {
                path: `${Paths.USER_GENERAL_INFORMATION}`,
                component: EditUserGeneralInformationPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.USER_GENERAL_INFORMATION,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.USER_SECURITY}`,
                component: EditUserSecurityPage,
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.USER_SECURITY,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            { path: '**', component: PageNotFoundComponent },
        ],
    },
];

@NgModule({
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes)],
})
export class UserAccountModule {}
